import { Media } from '../model/media.class';
import { Model } from '../model/model.class';

export class Version extends Model {

  public versionId: number;

  constructor(
    public number: number,
    public createdAt: Date,
    public media: Media,
    public comment: string,
    public versionStatus: string,
    public speakers: string[],
    public externalVersion: boolean
  ) {super(); }
}



// WEBPACK FOOTER //
// ./src/app/model/version.class.ts